export const HOMEPAGE = "/";
export const SIGNUPPAGE = "/auth/signup";
export const LOGINPAGE = "/auth/login";
export const VIEWALLORDERS = "/admin/view-all-orders";
export const CREATEMENU = "/admin/create-menu";
export const CREATEDISH = "/admin/create-dish";
